export enum RedirectStatus {
  Success = 'success',
  Canceled = 'cancel',
  Failure = 'fail',
}
